export enum EndpointParamEnum {
  ID = 'ID'
}
